<ng-container *ngIf="sessionLoaded else spinner">
	<div class="stu-login" [formGroup]="loginFormGroup" (ngSubmit)="onSubmit()" novalidate autocomplete="off">
		<div class="stu-login-logo">
			<mat-icon class="stu-login-logo-icon" svgIcon="am_with_text"></mat-icon>
		</div>
		<div *ngIf="errorStatus" class="stu-login-alert" role="alert" @appearAnimation>
			<div class="stu-login-alert-text" [ngSwitch]="errorStatus">
				<div class="stu-login-alert-title" translate>login.there-was-a-problem</div>
				<div translate>
					<ng-container *ngSwitchCase="'user_not_found'">login.user-not-found</ng-container>
					<ng-container *ngSwitchCase="'bad_password'">
						<p translate>login.bad-password</p>
						<p translate>login.password-attempts-exceeded</p>
					</ng-container>
					<ng-container *ngSwitchCase="'password_attempt_blocked'">login.password-attempts-blocked</ng-container>
					<ng-container *ngSwitchCase="'client_id_not_found'">login.client-id-not-found</ng-container>
					<ng-container *ngSwitchCase="'unknown_redirect_uri'">login.unknown-redirect-uri</ng-container>
					<ng-container *ngSwitchCase="'client_id_outdated'">login.client-id-outdated</ng-container>
					<ng-container *ngSwitchCase="'client_id_disabled'">login.client-id-disabled</ng-container>
					<ng-container *ngSwitchCase="'invalid_user_type'">login.user-doesnt-have-access</ng-container>
					<ng-container *ngSwitchDefault>login.unknown-error</ng-container>
				</div>
			</div>
			<button mat-icon-button type="button" aria-label="Close" (click)="errorStatus = undefined">
				<mat-icon svgIcon="md:close"></mat-icon>
			</button>
		</div>
		<ng-container *ngIf="!sessionContext || !sessionContext.authenticated">
			<form class="stu-login-form" [formGroup]="loginFormGroup" (ngSubmit)="onSubmit()" novalidate autocomplete="off">
				<div class="stu-login-problem-box">
					<h1 class="stu-login-title" translate>login.signin</h1>
				</div>
				<mat-form-field appearance="standard" [hideRequiredMarker]="true" class="stu-login-field">
					<mat-label translate>login.username</mat-label>
					<input matInput type="text" name="username" required autocomplete="username" autocapitalize="none" spellcheck="false" formControlName="username">
					<button type="button" *ngIf="loginFormGroup.get('username')!.value" matSuffix mat-icon-button (click)="loginFormGroup.get('username')!.reset('')" tabindex="-1" [disabled]="submitting">
						<mat-icon svgIcon="md:close" class="copo-small-close"></mat-icon>
					</button>
					<mat-error translate>login.username-required</mat-error>
				</mat-form-field>
				<mat-form-field appearance="standard" [hideRequiredMarker]="true" class="stu-login-field">
					<mat-label translate>login.password</mat-label>
					<input matInput type="password" name="password" required autocomplete="current-password" formControlName="password">
					<button type="button" *ngIf="loginFormGroup.get('password')!.value" matSuffix mat-icon-button (click)="loginFormGroup.get('password')!.reset('')" tabindex="-1" [disabled]="submitting">
						<mat-icon svgIcon="md:close" class="copo-small-close"></mat-icon>
					</button>
					<mat-error translate>login.password-required</mat-error>
				</mat-form-field>
				<div class="stu-login-remember">
					<mat-checkbox name="remember_me" value="true" formControlName="rememberMe"><span
							translate>login.remember-me</span></mat-checkbox>
					<a class="forgot-password-link" mat-button color="primary"
						[routerLink]="['/forgot-password']">{{ 'forgot.password' | translate }}
					</a>
				</div>
				<button mat-raised-button color="accent" class="stu-login-field" type="submit" [disabled]="submitting">
					<span *ngIf="!submitting; else submittingMessage" translate>login.signin</span>
					<ng-template #submittingMessage><span translate>login.loading</span></ng-template>
				</button>
			</form>
		</ng-container>
		<ng-container *ngIf="sessionContext && sessionContext.authenticated && !displayLinkAccount">
			<div class="stu-login-authenticated">
				<div class="stu-login-authenticated-as">
					<div><span translate>login.authenticated-as</span>&ngsp;<span class="stu-login-authenticated-name">{{ sessionContext.displayName }}</span></div>
				</div>
				<div class="stu-login-authenticated-no-access" *ngIf="!sessionContext.hasUserAccount"><span translate>login.but-no-account-ask-for-access</span>&ngsp;<a href="mailto:ebusiness.support@arcelormittal.com">ebusiness.support@arcelormittal.com</a></div>
				<div class="stu-login-continue-logout">
					<button *ngIf="sessionContext.hasUserAccount" mat-raised-button type="button" color="accent"
						(click)="continue()">
						<span translate>login.continue</span>
					</button>
					<button *ngIf="!sessionContext.hasUserAccount" mat-raised-button type="button" color="accent"
						(click)="linkYourAccount()">
						<span translate>login.link-steeluser-account</span>
					</button>
					<button mat-button type="button" (click)="logout()">
						<span translate>login.logout</span>
					</button>
				</div>
			</div>
		</ng-container>
		<ng-container *ngIf="sessionContext && sessionContext.authenticated && displayLinkAccount">
			<form class="stu-login-form" [formGroup]="linkingFormGroup" (ngSubmit)="onLinkingSubmit()" novalidate
				autocomplete="off">
				<div class="stu-login-problem-box">
					<h1 class="stu-login-title" translate>login.link-steeluser-account</h1>
				</div>
				<mat-form-field appearance="standard" [hideRequiredMarker]="true" class="stu-login-field">
					<mat-label translate>login.username</mat-label>
					<input matInput type="text" name="username" required autocomplete="username" autocapitalize="none"
						spellcheck="false" formControlName="username">
					<button type="button" *ngIf="linkingFormGroup.get('username')!.value" matSuffix mat-icon-button
						(click)="linkingFormGroup.get('username')!.reset('')" tabindex="-1" [disabled]="submitting">
						<mat-icon svgIcon="md:close" class="copo-small-close"></mat-icon>
					</button>
					<mat-error translate>login.username-required</mat-error>
				</mat-form-field>
				<mat-form-field appearance="standard" [hideRequiredMarker]="true" class="stu-login-field">
					<mat-label translate>login.password</mat-label>
					<input matInput type="password" name="password" required autocomplete="current-password"
						formControlName="password">
					<button type="button" *ngIf="linkingFormGroup.get('password')!.value" matSuffix mat-icon-button
						(click)="linkingFormGroup.get('password')!.reset('')" tabindex="-1" [disabled]="submitting">
						<mat-icon svgIcon="md:close" class="copo-small-close"></mat-icon>
					</button>
					<mat-error translate>login.password-required</mat-error>
				</mat-form-field>
				<div class="stu-login-continue-logout">
					<button mat-raised-button color="accent" type="submit" [disabled]="submitting">
						<span *ngIf="!submitting; else linkingMessage" translate>login.link</span>
						<ng-template #linkingMessage><span translate>login.linking</span></ng-template>
					</button>
					<button mat-button type="button" (click)="backFromLinkYourAccount()">
						<span translate>login.cancel</span>
					</button>
				</div>
			</form>
		</ng-container>
	</div>
	<div class="stu-login-copyright">
		© ArcelorMittal {{ year }}&ngsp;
		<a *ngIf="isPortal" (click)="openPrivacyPolicyDialog()">Privacy Settings</a>
	</div>
</ng-container>
<ng-template #spinner>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>